import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import IndianFLag from '../../assets/IndianFlag.svg';

const TrustMarker = (props) => {
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	const isDark =
		props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';

	const primaryColor = props.customDetails?.primaryColor || '#4A5EAD';
	const backgroundColor = isDark
		? '#2D2D2D'
		: `color-mix(in srgb, ${primaryColor} 5%, transparent)`;

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				gap: '10px',
				backgroundColor: backgroundColor,
				padding: props.noBorderRadius ? '8px 20px 8px 20px' : '10px 20px',
				borderRadius: props.noBorderRadius ? '0' : '8px',
				margin: props.noBorderRadius ? '0' : undefined,
			}}
		>
			<img src={IndianFLag} alt="People" style={{ display: 'block' }} />
			<Typography
				variant="body1"
				sx={{
					fontSize: mobileScreen ? '0.8rem' : '1rem',
					fontFamily: props.customDetails?.fontFamily,
					lineHeight: 1,
				}}
			>
				20 Cr+ Indians use Account Aggregator to share data
			</Typography>
		</Box>
	);
};

export default TrustMarker;
